module.exports = __webpack_public_path__ + "static/farmbot-bf7b2ffc08bf7728b645d6ed81714640.png";